import { stringify } from "qs";

export const PATH_POS_PARAMETER = "/app/poss/parameter";

export enum PosParameterTabs {
    Details = "details",
    ChannelMapping = "channel-mapping",
    ChannelInfo = "channel-info",
    PlatformConnection = "platform-connection",
    OtherSettings = "other-settings",
}

export function getPosDetailTabRoute(
    tab: PosParameterTabs,
    { posId }: { posId?: number } = {}
): string {
    return `${PATH_POS_PARAMETER}/${tab}${stringify({ posId }, { addQueryPrefix: true })}`;
}

const detailTabFactory =
    (tab: PosParameterTabs) =>
    ({ posId }: { posId?: number } = {}) =>
        getPosDetailTabRoute(tab, { posId });

export const posRoutes = {
    detailView: detailTabFactory(PosParameterTabs.Details),
    channelMappingView: detailTabFactory(PosParameterTabs.ChannelMapping),
    channelInfoView: detailTabFactory(PosParameterTabs.ChannelInfo),
    platformConnectionView: detailTabFactory(PosParameterTabs.PlatformConnection),
    otherSettingsView: detailTabFactory(PosParameterTabs.OtherSettings),
};
